import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet, HttpPost} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;
console.log("sub key xxx", SUBSCRIPTION_KEY)

const getTotalVerificationGroupByStatus = () => {
    let parameters = null;
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOTAL_VERIFICATION_GROUP_BY_STATUS, parameters, subscriptionKey);
    return result;
}

const getTotalAuthentication = () => {
    let parameters = null;
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOTAL_AUTHENTICATION, parameters, subscriptionKey);
    return result;
}

const getTopProductAuthVsVerification = (country, region) => {
    let query_params = {
        country: country,
        region: region
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOTAL_PRODUCT_AUTH_VS_VERIFICATION, query_params, subscriptionKey);
    return result;
}

const getTopProductAuthVsVerificationLatLong = (country, region) => {
    let query_params = {
        country: country,
        region: region
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOTAL_PRODUCT_AUTH_VS_VERIFICATION_LATLONG, query_params, subscriptionKey);
    return result;
}

const getTopVerifiedProducts = (country, region) => {
    let query_params = {
        country: country,
        region: region
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOP_VERIFIED_PRODUCTS, query_params, subscriptionKey);
    return result;
}

const getVerificationPerHour = (date) => {
    let query_params = {
        date: date
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_VERIFICATION_PER_HOUR, query_params, subscriptionKey);
    return result;
}

const getVerificationPerMonth= (year, product_code) => {
    let payload = {
        year: year,
        product_code: product_code
    }
    let result = HttpPost(routes.GET_VERIFICATION_PER_MONTH, payload);
    return result;
}

const getTopProductAuthenticationDetailView = (product_code) => {
    let query_params = {
        product_code: product_code
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_TOP_PRODUCT_AUTHENTICATION_DETAIL_VIEW, query_params, subscriptionKey);

    return result;
}


const AnalyticsService = {
    getTotalVerificationGroupByStatus,
    getTotalAuthentication,
    getTopProductAuthVsVerification,
    getTopProductAuthVsVerificationLatLong,
    getTopVerifiedProducts,
    getVerificationPerHour,
    getVerificationPerMonth,
    getTopProductAuthenticationDetailView
}

export default AnalyticsService
